import React, { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from 'reactstrap';
import {
  getImageUrl,
  getImageVariant,
} from '../../../../utility/util/util.service';
import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import PropTypes from 'prop-types';

const ItemCardCarousel = ({
  activeIndex,
  setActiveIndex,
  item,
  itemImageClassNames,
}) => {
  const [animating, setAnimating] = useState(0);

  const images = item?.data
    .map((data, index) => ({
      src: getImageUrl(data.image, getImageVariant('menuEntry')),
      image: data.image,
      id: index,
    }))
    .sort((a, b) => a.manualRanking - b.manualRanking);

  const onExiting = () => {
    setAnimating(true);
  };

  const onExited = () => {
    setAnimating(false);
  };

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = images.map((item) => {
    return (
      <CarouselItem onExiting={onExiting} onExited={onExited} key={item.id}>
        <LazyImage
          image={item.image}
          src={
            item?.image === null && '/assets/img/default_menu_entry_image.svg'
          }
          variant="menuEntry"
          className="h-100 mh-10 img-cover-center card-img"
          placeholderContainerClassNames="h-100 mh-10 w-100 line-height-1 d-block"
          placeholderClassNames="mh-10"
        />
      </CarouselItem>
    );
  });

  return (
    <Carousel
      className="w-100"
      activeIndex={activeIndex}
      next={next}
      previous={previous}
      interval={false}
    >
      <CarouselIndicators
        items={images}
        activeIndex={activeIndex}
        onClickHandler={goToIndex}
      />
      {slides}
      <div onClick={(e) => e.stopPropagation()}>
        <CarouselControl
          data-testid="backButtonCarousel"
          direction="prev"
          directionText="Previous"
          onClickHandler={previous}
        />
      </div>
      <div onClick={(e) => e.stopPropagation()}>
        <CarouselControl
          data-testid="nextButtonCarousel"
          direction="next"
          directionText="Next"
          onClickHandler={next}
        />
      </div>
    </Carousel>
  );
};

ItemCardCarousel.propTypes = {
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
  item: PropTypes.object,
  itemImageClassNames: PropTypes.string,
};

export default ItemCardCarousel;
